import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { constants } from 'src/app/shared/common/contants';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { LoginService } from 'src/app/shared/services/login.service';


export interface FormData {
  data:any,
  dnsId:any
}


@Component({
    selector: 'app-detect-changes-popup-vault-object',
    templateUrl: './detect-changes-popup-vault-object.component.html',
    styleUrls: ['./detect-changes-popup-vault-object.component.scss'],
    standalone: false
})
export class DetectChangesPopupVaultObjectComponent implements OnInit {

  headerNameHTML:any;
  gridAPI;

  lastPage;

  currentPage;

  nextPage;

  nextPagePlusOne;

  totalPages;

  gridColumnAPI;

  columnDefs:any;

  rowClassRules;

  defaultColDef;

  rowSelection;

  paginationPageSize;

  paginationNumberFormatter;
dnsId;
  pageSize;
  backgroundColorScreen="";
  value;
  backgroundColorButton = "";
  gridOptions:any;
  selectedObjects:any[]=[];
  constructor(private dialogref: MatDialogRef<DetectChangesPopupVaultObjectComponent>,

    @Inject(MAT_DIALOG_DATA) public data: FormData,
  
    private constants: constants,
    private service: CommonService,
    private snackBar: MatSnackBar,
    private sanitizer: DomSanitizer,
    private auth: LoginService,
    private dialog: MatDialog,
    private spinner: NgxUiLoaderService,
    private snackbar: MatSnackBar,
    private localStorageSettings:LocalStorageSettingsService,
   ) {
    this.dnsId=data.dnsId
    console.log("dnsId ====> "+this.dnsId)
   // this.onSelectionChanged = this.onSelectionChanged.bind(this);
  }

  ngOnInit(): void {
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
    this.columnDefs = [
    //   {
    //     headerCheckboxSelection: true,
    //     checkboxSelection: true,
    //     headerCheckboxSelectionFilteredOnly: true,
    //     width: 50
    // },
    
      {
        
          headerName: "Object Name",
          headerTooltip: "Object Name",
          tooltipValueGetter: params => "Selected  Objects : " + params.value,
          field: "objectname",
          filter: "agTextColumnFilter",
          width: 100,
       //   headerCheckboxSelectionFilteredOnly: true,
          //checkboxSelection: true,
          cellStyle: { " padding-left": "5px" }
        
      },
      
      {
        headerName: 'Attribute Name',
        headerTooltip: 'Attribute Name',
        tooltipValueGetter: (params) => params.value,
        field: 'fieldName',
        filter: 'agTextColumnFilter',
        width: 250,
        flex: 1,
      },
      {
        headerName: 'Change Type',
        headerTooltip: 'Change Type',
        tooltipValueGetter: (params) =>  params.value,
        field: 'changeType',
        filter: 'agTextColumnFilter',
        width: 250,
        flex: 1,
      },
      {
        headerName: 'Old Value',
        headerTooltip: 'Old Value',
        tooltipValueGetter: (params) =>  params.value,
        field: 'oldValue',
        filter: 'agTextColumnFilter',
        width: 350,
        flex: 1,
      },
      {
        headerName: 'New Value',
        headerTooltip: 'New Value',
        tooltipValueGetter: (params) =>  params.value,
        field: 'newValue',
        filter: 'agTextColumnFilter',
        width: 350,
        flex: 1,
      },
      {
        headerName: 'Last Modified Date & Time',
        headerTooltip: 'Last Modified Date & Time',
        tooltipValueGetter: (params) =>  params.value,
        field: 'modifiedDate',
        filter: 'agTextColumnFilter',
        width: 250,
        flex: 1,
      },
    ]

     // below object is resizable, sorting and filter for ag-grid
     this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.gridOptions = {
      // rowSelection: 'multiple',
      // onSelectionChanged: this.onSelectionChanged,
       onFirstDataRendered: (params) => {
         params.api.setGridOption('paginationPageSize', 10); // Set the desired row limit here
       }
    };

  }
  onSelectionChanged(){
    const selectedNodes = this.gridOptions.api.getSelectedNodes();
    const selectedData = selectedNodes.map(node => node.data);
    console.log("Selected Records:", selectedData);
    this.selectedObjects = selectedData;
  }

   //pagination code
   onPaginationChanged() {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1
      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1
      this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalPages = this.gridAPI.paginationGetTotalPages()
    }
  }

  /**
   * @Author Nitin kumar
   * @Date 16-06-2024
   * @param params 
   * method to load the Grid and its data
   */
   onGridReady(params) {
    this.gridAPI = params.api;
    this.gridColumnAPI = params.columnApi;
    this.gridOptions.api = params.api;
    this.gridOptions.columnApi = params.columnApi;
    //let dnsId = this.localStorageSettings.getSettings("dnsName")
    let vaultDnsname = this.localStorageSettings.getSettings("vaultDnsname");
   this.spinner.start();
   let refreshHistoryId = this.data.data;
    this.service.retrieveVaultObjectChanegs(this.dnsId,refreshHistoryId).subscribe(result => {
      if (result.error === true) {
        this.spinner.stop();

        this.snackbar.open(result.statusMessage, "OK", {duration: 5000});

      } else {

        console.log(result);   
      this.gridAPI.setGridOption('rowData', result);
      this.spinner.stop();

     
      }

    })
   
  }
  //this function is for going to the given page number
  onSearchChange(searchValue: number) {
    this.gridAPI.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {
    var value = this.pageSize;
    this.gridAPI.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridAPI.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridAPI.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    this.gridAPI.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    this.gridAPI.paginationGoToLastPage();
  }
  //pagination code ends

  cancel() {

    this.dialogref.close();

  }


 //excel export function
 onBtExport() {

  this.gridAPI.exportDataAsCsv();

}

importChanges() {

  console.log(this.selectedObjects);
  this.spinner.start();
  if(this.selectedObjects.length>0){
    this.service.importVaultChanges(this.dnsId,this.selectedObjects).subscribe(res=>{
      this.spinner.stop();
      console.log(res)
      this.dialogref.close();
      this.snackbar.open(" Objects Changes Imported successfully.", "OK", {duration: 5000})
    })
  }else{
    this.spinner.stop();
    this.snackbar.open("Please select Object to Import the changes.", "OK", {duration: 5000})
    

  }
  
}

}
